import { US_STATES } from 'utils/constants'

export const buildOption = state => ({
  label: US_STATES[state],
  value: state,
})
